/**
 * Feature flags for controlling app functionality
 * Following the Figma design alignment plan
 */

export const NAVBAR_FEATURES = {

  // Navigation buttons - hide per Figma design requirements
  showSearch: import.meta.env.VITE_SHOW_SEARCH === "true" || false,
  showDevChat: false,
  showChats: false,
  showPersonas: false,
  showAgents: true,

  // Conversation grouping - simplified per Figma design
  showTimeGrouping: false,

  // show the pinned chats feature
  showPinnedChats: import.meta.env.VITE_SHOW_PINNED_CHATS === "true" || false,


  // Keep New Chat button - required in Figma design
  showNewChat: true,
} as const;

export const FEATURES = {
  showSavePrompts: import.meta.env.VITE_SHOW_SAVE_PROMPTS === "true" || false,
  showDigitalMaintenanceCheckResult: import.meta.env.VITE_SHOW_DIGITAL_MAINTENANCE_CHECK_RESULT === 'true',
}
export type NavbarFeatureFlags = typeof NAVBAR_FEATURES;
